<template>
  <div class="findPass">
    <img :src="bannerImg" alt="">
    <div class="findMain">
      <h3 class="findEm">找回密码</h3>
      <div class="findForm">
        <el-form :model="ruleForm2" ref="ruleForm" class="">
          <div class="iphone-wrap" v-if="!showPass">
            <div class="d-input-box flex-b" label="手机号" prop="rgIphone" style="text-align:left;">
              <span>手机号<b style="color: red;padding: 0 5px;">*</b></span>
              <el-input v-model="ruleForm2.iphone" @keyup.native="clearSpace('iphone')" placeholder="请输入您的手机号" maxlength="11" name="iphone"></el-input>
            </div>
            <div class="d-input-box flex-b" style="text-align: left;" label="验证码" prop="rgCode">
              <span>验证码<b style="color: red;padding: 0 5px;">*</b></span>
              <el-input style="width:63%; margin-right: 5%;" @keyup.native="clearSpace('code')" v-model="ruleForm2.code" placeholder="请输入验证码" maxlength="4" name="code"></el-input>
              <el-button :style="btnAllStyle" type="primary" class="code-btn" @click='sendCode' :disabled='showCodeBtn'>{{codeText}}{{showCodeBtn?'s':''}}</el-button>
            </div>
          </div>
          <div class="pass-wrap" v-if="showPass">
            <div class="d-input-box flex-b" style="text-align: left;" label="新密码" prop="rgPassword">
              <span>新密码<b style="color: red;padding: 0 5px;">*</b></span>
              <el-input @keyup.native.space.passive="clearSpace('password')" name='password' v-model="ruleForm2.password" type="password" placeholder="请输入新密码" maxlength="18"></el-input>
              </div>
              <div class="d-input-box flex-b" style="text-align: left;" label="再次输入密码" prop="rgRePassword">
                <span>再次输入密码<b style="color: red;padding: 0 5px;">*</b></span>
                <el-input @keyup.native.space.passive="clearSpace('repasswrod')" name='repasswrod' v-model="ruleForm2.repasswrod" type="password" placeholder="请再次输入新密码" maxlength="18"></el-input>
              </div>
            </div>
            <el-button :style="btnAllStyle" type="primary" size="medium" @click="submitBtn('ruleForm')" style="margin: 15px auto;display: inherit;">提交</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api'
import reg from '../utils/regExp.js'
export default {
  name: 'FindPass',
  data() {
    return {
      bannerImg: sessionStorage.getItem('bannerImg'),
      ruleForm2: {
        userName: '',
        password: '',
        repasswrod: '',
        code: '',
        iphone: ''
      },
      showPass: false,
      showCodeBtn: false,
      codeText: '获取验证码',
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {}
    }
  },
  methods: {
    submitNewPasswrod(cb) {
      var _this = this;
      var obj = _this.ruleForm2;
      if(!reg.notEmpty.test(obj.password)) {
        _this.$alert('请输入您的新密码');
        document.getElementsByName('password')[0].focus();
        return ''
      } else if(obj.password.length < 6) {
        _this.$alert('新密码的长度不能低于6位');
        document.getElementsByName('password')[0].focus();
        return ''
      }else if(!reg.password.test(obj.password)) {
        _this.$alert('新密码的格式不正确,请不要包含空格或者特殊字符');
        document.getElementsByName('password')[0].focus();
        return ''
      }else if(!reg.notEmpty.test(obj.repasswrod)) {
        _this.$alert('请再次输入您的新密码');
        document.getElementsByName('repasswrod')[0].focus();
        return ''
      }else if(obj.password !== obj.repasswrod) {
        _this.$alert('两次密码输入不一致');
        document.getElementsByName('repasswrod')[0].focus();
        return ''
      }
      var param = {
        exhid: sessionStorage.getItem('ExhID'),
        psjid: _this.PsjID,
        pwd: _this.ruleForm2.password
      }
      api.UpdatePwd(param).then(res => {
        if(res.data.status === 'OK') {
          if (cb) {
            cb(res)
          }
        }else{
          _this.$alert(res.ErrorMsg, '提示');
        }
      })
    },
    countDown(codeText, cb) { // 倒计时sss
      var num = 60;
      var _this = this;
      var stop = setInterval(function() {
        num--;
        if(num < 0) {
          clearInterval(stop);
          if (cb) {
            cb()
          }
        }else{
          _this.codeText = num;
        }
      }, 1000)
    },
    getCode(cb) { // 滑块 验证码....
      var _this = this;
      var param1 = {
        exhid: sessionStorage.getItem('ExhID'),
        WapToken: sessionStorage.getItem('token')
      }
      var sign = '昆仑亿发';
      if (sessionStorage.getItem('SmsSign')) {
        sign = sessionStorage.getItem('SmsSign')
      }
      api.getVerifyToken(param1).then(res1 => {
        if(res1.data.status === 'OK') {
          var param = {
            ExhID: sessionStorage.getItem('ExhID'),
            sign: sign,
            RegistType: 'pc',
            NotUseCache: 'yes',
            mobile: _this.ruleForm2.iphone,
            openid: '',
            imgcode: '',
            token: res1.data.token,
            type: '',
            WapToken: param1.WapToken
          }
          api.getVerificationCode(param).then(res => {
            if(res.data.status === 'OK') {
              if (cb) {
                cb(res)
              }
            }else{
              _this.$alert(res.data.ErrorMsg, '提示')
            }
          })
        }else{
          _this.$alert(res1.data.ErrorMsg, '提示');
        }
      })
    },
    checkSliderCode(cb) {
      var _this = this;
      var iphone = _this.ruleForm2.iphone;
      var code = _this.ruleForm2.code;
      if (!reg.notEmpty.test(iphone)) {
        _this.$alert('请输入您的手机号');
        document.getElementsByName('iphone')[0].focus();
        return ''
      } else if (!reg.regCheckCnMobile.test(iphone)) {
        _this.$alert('手机格式错误,请重新输入');
        document.getElementsByName('iphone')[0].focus();
        return ''
      } else if(!reg.notEmpty.test(code)) {
        _this.$alert('请输入验证码');
        document.getElementsByName('code')[0].focus();
        return ''
      } else if (code.length !== 4) {
        _this.$alert('请输入4位验证码');
        document.getElementsByName('code')[0].focus();
        return ''
      } else if(!reg.code.test(code)) {
        _this.$alert('验证码格式错误,请重新输入');
        document.getElementsByName('code')[0].focus();
        return ''
      }
      var param = {
        ExhID: sessionStorage.getItem('ExhID'),
        Code: _this.ruleForm2.code,
        Mobile: _this.ruleForm2.iphone,
        NotUseCache: '',
        PsnName: ''
      };
      api.CheckVerificationCodeF(param).then(res => {
        if(res.data.status === 'OK') {
            if (res.data.PsjID) {
              _this.PsjID = res.data.PsjID;
              sessionStorage.setItem('PsnID', res.data.PsnID);
              sessionStorage.setItem('PsjID', res.data.PsjID);
              _this.showPass = true
            } else {
              _this.$alert('此手机号未完成注册');
            }
          } else {
            _this.$alert(res.data.ErrorMsg, '提示')
          }
      })
    },
    clearSpace(n) {
      var _this = this;
      var obj = _this.ruleForm2;
      if (n === 'password' || n === 'repasswrod') {
        obj[n] = obj[n].trim();
      }else if(n === 'iphone' || n === 'code') { // 数字
        obj[n] = obj[n].replace(/\D/g, '');
      }else{
        obj[n] = obj[n].replace(/\s+/img, '');
      }
      _this.ruleForm2 = obj;
      return false;
    },
    submitBtn(elemRef) {
      var _this = this;
      if(!_this.showPass) { // 验证 短信code
        _this.checkSliderCode();
      }else{ // 提交新密码
        _this.submitNewPasswrod(res => {
          if(res.data.status === 'OK') {
            sessionStorage.setItem('PsjID', _this.PsjID);
            this.$router.push({path: '/login', query: {ExhID: sessionStorage.getItem('ExhID')}})
          }else{
            _this.$alert(res.data.ErrorMsg)
          }
        })
      }
    },
    sendCode() {
      var _this = this;
      var iphone = _this.ruleForm2.iphone;
      if (!reg.notEmpty.test(iphone)) {
        _this.$alert('请输入您的手机号');
        document.getElementsByName('iphone')[0].focus();
        return ''
      }else if (!reg.regCheckCnMobile.test(iphone)) {
        _this.$alert('手机格式错误,请重新输入');
        document.getElementsByName('iphone')[0].focus();
        return ''
      }
      var param = {
        exhid: sessionStorage.getItem('ExhID'),
        PsnMobile: _this.ruleForm2.iphone
      }
      api.PsnMobileRepeat(param).then(rq => { // 手机号是否注册
        if(rq.data.status === 'OK') { // 未注册
          _this.$alert('此手机号未注册')
        }else{ // 注册
          _this.getCode(function(res) {
            _this.showCodeBtn = true;
            _this.countDown('codeText', function() {
              _this.showCodeBtn = false;
              _this.codeText = '重新获取验证码'
            })
          })
        }
      })
    }
  }
}
</script>
<style>
.findForm{
  width: 42%;
  margin: 60px auto;
}
.flex-b{
  display: flex;
  align-items: center;
}
.code-btn{
  width: 22%;
  text-align: center;
}
.d-input-box{
  padding:12px 0;
}
.d-input-box>span{
  width: 160px;
  text-align: right;
}
.findMain{
  background: #fff;
  padding-bottom: 30px;
}
.findPass{
  width: 80%;
  margin: 0 auto;
  max-width: 1180px;
  padding-bottom: 30px;
}
.findPass img{
  width: 100%;
}
.findEm{
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/FindPass.vue